import React from 'react'
import PropTypes from 'prop-types'
import CustomerForm from "../shared/CustomerForm"
import parseToken from "../../../../helpers/parseToken"
import {formatDate} from "../../../../helpers/formatDate"
import {getLocalData} from "../../../../services/StorageServices"
import {callPhone} from "../../../../services/api/apiPhoneConnect"
import {message} from "antd"
import {onAddTab, onChangeActiveTab, onRemoveTab} from "../../../../store/action"
import {connect} from "react-redux"

CustomersItem.propTypes = {
    item: PropTypes.object
}

function CustomersItem(props) {
    const decodeToken = parseToken()
    const {item, index, page, limit, onAddTab} = props
    const listPhone = !!item && !!item.phone && item.phone.split(',')

    const _callPhoneOut = async (phoneNumber) => {
        try {
            const ipPhone = getLocalData('ipPhone')
            const user = getLocalData('userLoginPhone')
            const payload = {
                phoneNumber: phoneNumber,
                ext: ipPhone,
                transactionId: item.customerId,
                userName: user,
                outSys: "CRM",
                type: "customer"
            }

            const response = await callPhone(payload)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onAddTabDetail = (id, name) => {
        const payload = {
            idLeadDetail: id,
            id: `customerDetail_${id}`,
            title: name,
            icon: ''
        }

        onAddTab(payload)
    }

    return (
        <tr className="CustomersItem">
            <td className="Stt">{(page - 1) * limit + index + 1}</td>
            <td className="Name">
                 <span
                     className="cursor-pointer text-primary"
                     onClick={() => _onAddTabDetail(item.customerId, item.name)}
                 >
                     {item.name || ''}
                 </span>
                <span className="CreateAt">
                    {formatDate(item.createdAt)}
                </span>
            </td>
            <td className="Phone">
                {
                    !!listPhone && listPhone.map((item, index) => (
                        <span key={index} onClick={() => _callPhoneOut(item)}>{item},</span>
                    ))
                }
            </td>
            <td className="Address">{item.address}</td>
            <td className="Description">{item.description}</td>
            <td className="Source">{item.source}</td>
            <td className="Actions">
                <CustomerForm item={item} createBy={decodeToken.sub} label="Sửa thông tin khách hàng" type="edit"/>
            </td>
        </tr>
    )
}

const mapStateToProps = (state) => {
    return {
        tabs: state.tabsReducer.tabs,
        tabActive: state.tabsReducer.tabActive
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddTab: (data) => dispatch(onAddTab(data)),
        onRemoveTab: (data) => dispatch(onRemoveTab(data)),
        onChangeActiveTab: (data) => dispatch(onChangeActiveTab(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersItem)
